import Box from '~/common/components/Box';
import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';

type PaystubYTDProps = {
  fiscalYear: string | number;
  variableTitle: string;
  currentYearIncome?: {
    incomeType?: string;
    annualIncome?: number;
    monthlyAmount?: number;
    totalYearToDateIncome?: number;
  }[];
};

export default function PaystubYTD({
  fiscalYear,
  currentYearIncome = [],
  variableTitle,
}: Readonly<PaystubYTDProps>) {
  return (
    <Box mb={5}>
      <Text
        mr={1}
        pb={4}
        fontSize="md"
        fontWeight="bold"
        textDecoration="underline"
        data-testid={'paystub-fiscalyear'}
      >
        Paystub ({fiscalYear})
      </Text>

      <Flex alignItems={'flex-end'}>
        <Box>
          <Text mr={6} fontSize="md">
            Paystub Total
          </Text>
          <Text mr={6} fontSize="md">
            Monthly
          </Text>
          {variableTitle && (
            <Text mr={6} fontSize="md" data-testid="variable-title">
              {variableTitle}
            </Text>
          )}
        </Box>

        {currentYearIncome.length > 0 &&
          currentYearIncome.map(
            ({
              incomeType,
              monthlyAmount,
              annualIncome,
              totalYearToDateIncome,
            }) => (
              <Box
                key={`paystub-${fiscalYear}`}
                mr={6}
                data-testid="paystub-items"
              >
                <Text mr={1} fontSize="md" fontWeight="bold">
                  {incomeType}
                </Text>
                <Text fontSize="md" display="inline">
                  {formatCurrency(totalYearToDateIncome)}
                </Text>
                <Text fontSize="md">{formatCurrency(monthlyAmount)}</Text>
                {variableTitle && (
                  <Text fontSize="md">{formatCurrency(annualIncome)}</Text>
                )}
              </Box>
            ),
          )}
      </Flex>
    </Box>
  );
}
